import VueCookie from 'vue-cookie'

export default {
  methods: {
    checkToken () {
      const token = VueCookie.get('token')
      const googleToken = VueCookie.get('googleToken')
      if ((!token || !googleToken) && this.$route.name !== 'SingIn') {
        this.$router.push({name: 'SingIn'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/checkToken.js